/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Card, Col, Row, Space } from 'antd'
import { menuAdjustPointReason, menuPointAdjustType, PointAdjustType } from 'helpers/constanst'
import { formValidation, isFormError, isFormRequired } from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { AppInput, AppSelect } from 'Components/form'
import { cloneDeep } from 'lodash'
import { MyTheme } from 'Components/common/Theme'
import PointSummary from './PointSummary'
import { AdjustMemberPointListReq } from 'Store/member-point/types'
import { PrimaryButton } from 'Components/button'
import { adjustMemberPointAPI } from 'Store/member-point/api'
import { clearEventAction } from 'Store/member-point/actions'
import { EventModal } from 'Components/modal'
import { selectMemberPointInfo, selectUpdateActionEvent } from 'Store/member-point/selector'
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { getUserLogin } from 'helpers/account'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  id?: number
}

const PointAdjustment: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, onSuccess = () => {}, currentUser, id, event, pointInfo } = props
  const initForm = {
    id: id,
    point: 0,
    reason: '',
    remark: '',
    type: PointAdjustType.EARN,
    update_by: currentUser?.username || '',
    other_reason: '',
  } as AdjustMemberPointListReq
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [formError, setFormError] = useState([] as string[])
  const isOtherReason = formData.reason === 'other'
  const normalRequireFeild = ['type', 'reason', 'point']
  const otherRequireFeild = ['type', 'reason', 'point', 'other_reason']
  const requireFeild = isOtherReason ? otherRequireFeild : normalRequireFeild
  const userInfo = getUserLogin()

  useEffect(() => {
    // clear form data when user cloase drawer
    if (!visible) {
      setFormData(cloneDeep(initForm))
      setFormError([])
    }
  }, [visible])
  const dispatch = useDispatch()

  const onSave = (): void => {
    if (!validateForm()) return
    const req: AdjustMemberPointListReq = {
      ...formData,
      id: id || 0,
      reason: isOtherReason ? formData.other_reason : formData?.reason,
      // point: formData?.point,
      // remark: formData?.remark,
      // type: formData?.type,
      update_by: userInfo?.username || '',
    }
    dispatch(adjustMemberPointAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)

    setFormError([...error])
    return error.length > 0 ? false : true
  }

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }
  const currentPoint = pointInfo?.data?.point || 0

  const onUpdateData = (val: any, key: string) => {
    let value = cloneDeep(val)
    if (formData?.type === PointAdjustType.BURN && key === 'point' && parseInt(value) > currentPoint) {
      value = currentPoint
    }
    if (key === 'type' && formData.type !== value) {
      setFormData({
        ...formData,
        [key]: value,
        point: 0,
      })
    } else {
      setFormData({
        ...formData,
        [key]: value,
      })
    }
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
  }

  const title = (
    <Space>
      <span>จัดการคะแนน</span>
    </Space>
  )

  const renderFooterContent = () => {
    return (
      <Row justify="start" align="middle" gutter={[8, 8]}>
        <Col>
          <PrimaryButton btnType="Cancel" text={`ยกเลิก`} onClick={onCloseDrawer} />
        </Col>
        <Col>
          <PrimaryButton btnType="Primary" text={`บันทึก`} onClick={onSave} />
        </Col>
      </Row>
    )
  }

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={renderFooterContent()}
      width={'50%'}
    >
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={[16, 8]}>
        <Col span={24}>
          <PointSummary id={id} visible={visible} />
        </Col>
        <Col span={24}>
          <BoxTitle>จัดการคะแนนของสมาชิก</BoxTitle>
        </Col>
        <Col span={24}>
          <Row gutter={[12, 12]}>
            {menuPointAdjustType.map((item, key: number) => {
              return (
                <Col span={12} onClick={() => onUpdateData(item.value, 'type')} key={key}>
                  <CardPrice className={formData.type === item.value ? 'actived' : ''}>
                    {item.value === PointAdjustType.EARN ? <PlusCircleOutlined /> : <MinusCircleOutlined />}{' '}
                    &nbsp; {item.name}
                  </CardPrice>
                </Col>
              )
            })}
          </Row>
        </Col>
        <Col md={24} xs={24}>
          <AppInput
            label="ระบุจำนวนคะแนน"
            isRequired={isRequired('point')}
            isError={isError('point')}
            name="point"
            value={formData.point}
            onChange={onUpdateData}
            type="number"
          />
        </Col>
        <Col md={24} xs={24}>
          <AppSelect
            name="reason"
            label="เหตุผลในการทำรายการ"
            placeHolder="เลือกเหตุผลในการทำรายการ"
            isRequired={isRequired('reason')}
            isError={isError('reason')}
            value={formData.reason}
            onChange={onUpdateData}
            menu={menuAdjustPointReason}
            allowClear={false}
          />
          {isOtherReason && (
            <AppInput
              name="other_reason"
              label="ระบุเหตุผล"
              isRequired={true}
              isError={isError('other_reason')}
              value={formData.other_reason}
              onChange={onUpdateData}
            />
          )}
        </Col>
        <Col md={24} xs={24}>
          <AppInput
            label="หมายเหตุ (ถ้ามี)"
            isRequired={isRequired('remark')}
            isError={isError('remark')}
            name="remark"
            value={formData.remark}
            onChange={onUpdateData}
          />
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const CardPrice = styled(Card.Grid)`
  width: 100%;
  cursor: pointer;
  text-align: center;
  margin-bottom: 20px;
  border-radius: 10px;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  &.actived {
    background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
    span,
    div {
      color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
    }
  }

  @media only screen and (max-width: 720px) {
    width: 100%;
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectUpdateActionEvent(state),
    pointInfo: selectMemberPointInfo(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PointAdjustment)
